const STATUS_CLS = {
  'COMPLETE':    'status-complete',
  'IN PROGRESS': 'status-in-progress',
  'NOT STARTED': 'status-not-started',
};

export function HubNode({ hub, active, pulse, onOpen }) {
  const cls = STATUS_CLS[hub.status] ?? 'status-not-started';

  return (
    <div
      className={`node${active ? ' active' : ''}${pulse ? ' pulse' : ''}`}
      style={{ left: hub.pos_x, top: hub.pos_y, width: hub.width, height: hub.height }}
      onClick={() => onOpen(hub.slug)}
    >
      <div className="node-head">
        <span className="idx">{hub.idx}</span>
        <span className={`node-status ${cls}`}>{hub.status}</span>
      </div>

      <div className="node-title">{hub.title}</div>
      <div className="node-body">{hub.summary}</div>

      <div className="node-foot">
        <span>COMPLETION</span>
        <span>{hub.pct != null ? `${hub.pct}%` : '—'}</span>
      </div>

      <div style={{ height: 3, background: active ? 'rgba(58,100,117,0.15)' : 'var(--hairline)', flexShrink: 0 }}>
        {hub.pct != null && (
          <div style={{ height: '100%', width: `${hub.pct}%`, background: active ? 'var(--paper)' : 'var(--ink)' }} />
        )}
      </div>
    </div>
  );
}

export default HubNode;
